import { Injectable } from '@angular/core';
import { CrudService } from 'collection';
import { CrudEntityModel } from 'collection';
import { GetEntityModel } from 'collection';
import { PostEntityModel } from 'collection';
import { UpdateEntityModel } from 'collection';

@Injectable({
  providedIn: 'root'
})
export class ApiService {
  login: PostEntityModel;
  resetPassword: PostEntityModel;
  register: PostEntityModel;
  userRegistration: PostEntityModel;
  logout: PostEntityModel;
  timeTracking: CrudEntityModel;
  reports: CrudEntityModel;
  projects: CrudEntityModel;
  clients: CrudEntityModel;
  tasks: CrudEntityModel;
  defaultTask: CrudEntityModel;
  materials: CrudEntityModel;
  materialUnits: CrudEntityModel;
  workers: CrudEntityModel;
  workerAvailableNumber: GetEntityModel;
  quickFills: CrudEntityModel;
  enhancedPayments: CrudEntityModel;
  salaryCodes: CrudEntityModel;
  overtimes: CrudEntityModel;
  wages: CrudEntityModel;
  projectSettings: CrudEntityModel;
  clientsSettings: CrudEntityModel;
  roles: CrudEntityModel;
  languages: CrudEntityModel;
  accountInfo: CrudEntityModel;
  countries: CrudEntityModel;
  subscriptionUpdate: UpdateEntityModel;
  subscription: GetEntityModel;
  subscriptionPaymentPlans: GetEntityModel;
  hoursAccountCapacity: GetEntityModel;
  hoursAccountCapacitySettings: CrudEntityModel;
  hoursAccountCapacityBatchUpdate: UpdateEntityModel;
  userMyProfile: CrudEntityModel;
  accountSettings: CrudEntityModel;
  userQualifications: CrudEntityModel;
  reportsVisibleColumns: CrudEntityModel;
  externalIntegrations: CrudEntityModel;
  integrations: CrudEntityModel;
  qualifications: CrudEntityModel;
  hoursAccountSettings: CrudEntityModel;
  absenceType: CrudEntityModel;
  absenceSettings: CrudEntityModel;
  absence: CrudEntityModel;
  checklists: CrudEntityModel;

  constructor(private crud: CrudService) {
    this.login = this.crud.createPostEntity({ name: 'login' });
    this.resetPassword = this.crud.createPostEntity({ name: 'password-reset' });
    this.register = this.crud.createPostEntity({ name: 'register' });
    this.userRegistration = this.crud.createPostEntity({ name: 'user-registration/:token' });
    this.logout = this.crud.createPostEntity({ name: 'logout' });
    this.reports = this.crud.createEntity({ name: 'report' });
    this.timeTracking = this.crud.createEntity({ name: 'time-tracking' });
    this.projects = this.crud.createEntity({ name: 'project' });
    this.userQualifications = this.crud.createEntity({ name: 'user-qualifications' });
    this.qualifications = this.crud.createEntity({ name: 'qualifications' });
    this.clients = this.crud.createEntity({ name: 'client' });
    this.tasks = this.crud.createEntity({ name: 'task' });
    this.defaultTask = this.crud.createEntity({ name: 'default-task' });
    this.workers = this.crud.createEntity({ name: 'worker' });
    this.workerAvailableNumber = this.crud.createGetEntity({ name: 'worker/available-number' });
    this.quickFills = this.crud.createEntity({ name: 'quick-fill' });
    this.enhancedPayments = this.crud.createEntity({ name: 'enhanced-payments' });
    this.materials = this.crud.createEntity({ name: 'materials' });
    this.materialUnits = this.crud.createEntity({ name: 'materials-units' });
    this.salaryCodes = this.crud.createEntity({ name: 'salary-codes' });
    this.overtimes = this.crud.createEntity({ name: 'overtimes' });
    this.wages = this.crud.createEntity({ name: 'wages' });
    this.projectSettings = this.crud.createEntity({ name: 'project-settings' });
    this.clientsSettings = this.crud.createEntity({ name: 'client-settings' });
    this.roles = this.crud.createEntity({ name: 'worker/roles' });
    this.accountInfo = this.crud.createEntity({ name: 'account/info' });
    this.languages = this.crud.createEntity({ name: 'language' });
    this.countries = this.crud.createEntity({ name: 'country' });
    this.subscriptionUpdate = this.crud.createUpdateEntity({ name: 'subscription/update' });
    this.subscription = this.crud.createGetEntity({ name: 'subscription' });
    this.subscriptionPaymentPlans = this.crud.createGetEntity({ name: 'subscription/payment-plans' });
    this.hoursAccountCapacity = this.crud.createGetEntity({ name: 'hours-account/capacity' });
    this.hoursAccountCapacitySettings = this.crud.createEntity({ name: 'hours-account/capacity-settings' });
    this.hoursAccountCapacityBatchUpdate = this.crud.createUpdateEntity({ name: 'hours-account/capacity/batch' });
    this.userMyProfile = this.crud.createEntity({ name: 'user/my-profile' });
    this.accountSettings = this.crud.createEntity({ name: 'account/settings' });
    this.reportsVisibleColumns = this.crud.createEntity({ name: 'user-settings/visible-columns' });
    this.externalIntegrations = this.crud.createEntity({ name: 'external-integrations' });
    this.integrations = this.crud.createEntity({ name: 'integrations' });
    this.hoursAccountSettings = this.crud.createEntity({ name: 'hours-account/settings' });
    this.absenceType = this.crud.createEntity({ name: 'absence-type' });
    this.absenceSettings = this.crud.createEntity({ name: 'absence-settings' });
    this.checklists = this.crud.createEntity({ name: 'checklist' });
  }
}
